// NOTE: Ensure these paths are correct for your project structure.
// These paths assume 'assets.js' and 'links.js' are in a directory one level up.
import { ASSET_PATHS } from "../assets"; // Example corrected path
import { all_links } from "../links";     // Example corrected path
import captcha_grid from "/public/captcha_grid.svg";

// --- CORE CONSTANTS ---
export const TOTAL_BOSSES = 7;
export const HEALTH_BAR_STAGES = 4;
export const JUMP_DURATION = 0.15;

// --- DYNAMIC CONSTANTS ---
// A function to get values that depend on the window size
export const getDynamicConstants = () => {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  return {
    IS_MOBILE: isMobile,
    JUMP_HEIGHT: isMobile ? 15 : 30,
  };
};

// --- DATA ---
export const BOSS_STATS = [
  { name: "BLS OCR",docsUrl: "/docs/solvers/recaptcha-v2",speed: "0.8s", cost: "$0.15", market: "3x cheaper" },
  { name: "PopularCaptcha", docsUrl: "/docs/solvers/recaptcha-v2", speed: "1.2s", cost: "$0.15", market: "2.5x cheaper" },
  { name: "TikTok", docsUrl: "/docs/solvers/recaptcha-v2", speed: "2.4s", cost: "$0.15", market: "3.2x cheaper" },
  { name: "CaptchaFox", docsUrl: "/docs/solvers/recaptcha-v2", speed: "2.4s", cost: "$0.15", market: "3.2x cheaper" },
  { name: "MtCaptcha", docsUrl: "/docs/solvers/recaptcha-v2", speed: "1.8s", cost: "$0.45", market: "3x cheaper" },
  { name: "reCAPTCHA v2", docsUrl: "/docs/solvers/recaptcha-v2", speed: "0.8s", cost: "$0.14", market: "3x cheaper" },
  { name: "Geetest", docsUrl: "/docs/solvers/recaptcha-v2", speed: "1.2s", cost: "$0.15", market: "2.5x cheaper" },
  // { name: "Geetest", docsUrl: "/docs/solvers/recaptcha-v2", speed: "2.1s", cost: "$0.50", market: "2.8x cheaper" },
];

// --- ASSET PATHS ---
export const ASSETS = {
  sonic: "/assets/images/sonic.svg",
  healthBarBase: "/assets/healthBar/1.svg",
  healthBarHit: [
    "/assets/healthBar/2.svg",
    "/assets/healthBar/3.svg",
    "/assets/healthBar/4.svg",
    "/assets/healthBar/5.svg",
  ],
  completedIcon: "/assets/check.svg",
  bossLogo: (i) => `/assets/logos/${i}.png`,
  bannerBg: (i) => `/assets/heroBannerBG/banner ${i}.svg`,
  banner: (i) => `/assets/heroBanner/hero banner ${i}.svg`,
};

// --- EXTERNAL IMPORTS ---
// Re-exporting for easy access from other components
export { ASSET_PATHS, all_links, captcha_grid };